import {parseISO} from 'date-fns'
import Big from 'big.js'
import {fixNumber} from '.'

export const reduceArrayNumber = (arr: any[], prop: string = 'amount'): number => {
  return arr.reduce(
    (total, item) => Big(total).add( ((prop ? item[prop] : item) ?? 0) ).toNumber(),
    0
  )
}

export const totalNumberFromArray = (arr: any[], prop?: string): number =>
  fixNumber(
    arr.reduce((total, item) => total + ((prop ? item[prop] : item) ?? 0), 0)
  )

export const lastUpdatedItemFromArray = (arr: any[]): any => {
  const sortedArray = [...arr]
  sortedArray.sort((a, b) => +parseISO(b.updatedAt) - +parseISO(a.updatedAt))
  return sortedArray[0]
}
